import { fromZonedTime, toZonedTime } from "date-fns-tz";
import {
  addSeconds,
  addMinutes,
  addHours,
  addDays,
  addMonths,
  addYears,
  subDays,
  subHours,
  subMonths,
  subYears,
} from "date-fns";

const withTimezone =
  (fn: (date: Date, delta: number) => Date) =>
  (date: Date, delta: number, timezone?: string): Date => {
    if (timezone) {
      const zoned = toZonedTime(date, timezone);
      return fromZonedTime(fn(zoned, delta), timezone);
    }
    return fn(date, delta);
  };

export const addSecondsToDate = (
  date: Date,
  seconds: number,
  timezone?: string
): Date => withTimezone(addSeconds)(date, seconds, timezone);

export const addMinutesToDate = (
  date: Date,
  minutes: number,
  timezone?: string
): Date => withTimezone(addMinutes)(date, minutes, timezone);

export const addHoursToDate = (
  date: Date,
  hours: number,
  timezone?: string
): Date => withTimezone(addHours)(date, hours, timezone);

export const addDaysToDate = (
  date: Date,
  days: number,
  timezone?: string
): Date => withTimezone(addDays)(date, days, timezone);

export const addYearsToDate = (
  date: Date,
  years: number,
  timezone?: string
): Date => withTimezone(addYears)(date, years, timezone);

export const addMonthsToDate = (
  date: Date,
  months: number,
  timezone?: string
): Date => withTimezone(addMonths)(date, months, timezone);

export const subtractMonthsFromDate = (
  date: Date,
  months: number,
  timezone?: string
): Date => withTimezone(subMonths)(date, months, timezone);

export const subtractHoursFromDate = (
  date: Date,
  hours: number,
  timezone?: string
): Date => withTimezone(subHours)(date, hours, timezone);

export const subtractDaysFromDate = (
  date: Date,
  days: number,
  timezone?: string
): Date => withTimezone(subDays)(date, days, timezone);

export const subtractYearsFromDate = (
  date: Date,
  years: number,
  timezone?: string
): Date => withTimezone(subYears)(date, years, timezone);
